import { LegalPage } from './LegalPage';

/** Copy lives in content/fallbacks.ts (legal.refund / legal.refundMeta) and is
 *  editable from admin → Marketing content → Legal. */
export function Refund() {
  return <LegalPage kind="refund" />;
}
